const napoChannels: string[] = [];

export default function hasNapoComments(article: any) {
  return napoChannels.includes(article.primaryCategory.channel.url);
}
